import { z } from "zod";
/** UUIDv7 — sortable by creation time, which we rely on for cursor pagination. */
export const resourceId = z.string().uuid();
export const isoTimestamp = z.string().datetime({ offset: true });
export const taskStatuses = ["todo", "in_progress", "review", "done", "cancelled"];
export const taskStatus = z.enum(taskStatuses);
export const taskPriorities = ["low", "normal", "medium", "high", "urgent"];
export const taskPriority = z.enum(taskPriorities);
export const projectHealths = ["on_track", "at_risk", "off_track"];
export const projectHealth = z.enum(projectHealths);
export const roles = ["admin", "manager", "editor", "member", "viewer"];
export const role = z.enum(roles);
export const channelKinds = ["project", "team", "direct"];
export const channelKind = z.enum(channelKinds);
/** Cursor pagination — `cursor` is the id of the last item from the prior page. */
export const pagination = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: resourceId.optional(),
});
export const errorResponse = z.object({
    error: z.string(),
    code: z.string().optional(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=primitives.js.map